var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlades(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9999 4.98148C21.9999 4.45198 21.7937 3.95414 21.4192 3.57973C20.6463 2.80676 19.3886 2.80676 18.6157 3.57973L10.5605 11.6349L13.3641 14.4384L21.4192 6.38328C21.7937 6.00883 21.9999 5.51102 21.9999 4.98148V4.98148Z",
    fill: "#FFB443"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.56488 13.6279L9.71975 12.4731L12.5229 15.2762L11.368 16.4311L8.56488 13.6279Z",
    fill: "#FFB443"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.04822 14.7861L2 20.8344L5.40969 20.6964C6.12025 20.6676 6.78844 20.3749 7.29122 19.8721L10.2127 16.9507L8.04822 14.7861Z",
    fill: "#FFB443"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlades);
export default __webpack_public_path__ + "static/media/blades.143e4778b03ff9c074a5edc08f7a642b.svg";
export { ForwardRef as ReactComponent };